export const baseRemovalModalMessageInfo = ({
  titleText: 'general.message.delete.title',
  buttonText: 'general.action.delete'
});
